import * as React from "react";
import { parsedToken } from "../../../../service/storageHelper";
import DeviceContext from "../../../../service/indentifyDevice";
import { IListObj } from "../../../../types/genericTypes";
import { IcommLimits, IftPayoutDeatils } from "../../../../types/components/fundTransfer/ftTypes";
import { FtPayInCashHeader } from "../../ftPayInCont/ftPayInCashHeader";
import FtPayoutFormCont from "./ftPayOutFormCont";
import RadioButton from "../../../../generic/radioButton";
import FtPayOutPending from "../ftPayOutPending";
import { Idevice } from "../../../../types/device";
import { useQuery } from "../../../../service/urlHelper";

const handleDevice: Idevice = DeviceContext();

if (handleDevice.isDesktop) {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftAddFundDesk.scss");
} else if (handleDevice.isMobile) {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftAddFundMob.scss");
} else {
	require("../../../../../assets/scss/components/toc/fundTransfer/ftAddFund/ftAddFundTab.scss");
}

export interface IFtPayOutProps {
	eq: IftPayoutDeatils;
	co: IftPayoutDeatils;
	eqCash: string;
	coCash: IcommLimits;
}

function FtPayOut(props: IFtPayOutProps) {
	const pToken = parsedToken();
	const queryAsset = useQuery().get("asset");

	let defaultAssetSel: string = pToken ? (pToken.accType === "COMEQ" ? "EQ" : pToken.accType) : "EQ";

	if (pToken?.accType === "COMEQ") {
		if (queryAsset && (queryAsset.toUpperCase() === "EQ" || queryAsset.toUpperCase() === "CO")) {
			defaultAssetSel = queryAsset.toUpperCase();
		}
	}

	const [selAssetBnkAccs, setAssetBnkAccs] = React.useState<Array<any>>(defaultAssetSel === "EQ" ? props.eq.bnkAcs : props.co.bnkAcs);
	const [selAssetDetails, setAssetDetails] = React.useState<IftPayoutDeatils>(defaultAssetSel === "EQ" ? props.eq : props.co);

	const [asset, setAsset] = React.useState<string>(defaultAssetSel);

	const assetList: Array<IListObj> = [
		{ value: "EQ", display: "Equity" },
		{ value: "CO", display: "Commodity" }
	];
	React.useEffect(() => {
		switch (asset) {
			case "EQ":
				setAssetBnkAccs(props.eq.bnkAcs);
				setAssetDetails(props.eq);
				break;
			case "CO":
				setAssetBnkAccs(props.co.bnkAcs);
				setAssetDetails(props.co);
				break;
			default:
				break;
		}
	}, [asset, props.eqCash, props.coCash]);
	return (
		<div className="ft_add_fund">
			<FtPayInCashHeader eqCash={props.eqCash} coCash={props.coCash} />
			<form>
				{pToken && pToken.accType === "COMEQ" && (
					<div className={"form-field asset_radio_section " + (selAssetDetails.pndPayout ? "pd-b0" : "pd-b40")}>
						<label className="input-label">Select Asset</label>
						<ul className="radio_wrap ledger_radio">
							{assetList.map((item) => (
								<li key={item.value} className="list_Item">
									<RadioButton
										list={{
											value: item.value,
											display: item.display
										}}
										name={"cvtPosition"}
										selected={asset}
										onChange={() => setAsset(item.value as string)}
									/>
								</li>
							))}
						</ul>
					</div>
				)}

				{selAssetDetails.pndPayout && asset ? (
					<FtPayOutPending data={selAssetDetails} asset={asset} />
				) : (
					<FtPayoutFormCont bnkAcs={selAssetBnkAccs} asset={asset} eqCash={props.eqCash} coCash={props.coCash} />
				)}
			</form>
		</div>
	);
}

export default FtPayOut;
